import type { EditorPlugin } from '../../types/aha-editor';
import AnnotationsChangeHandler from './AnnotationsChangeHandler';
import AnnotationsPastePlugin from './AnnotationsPastePlugin';
import AnnotationsDecorator from './AnnotationsDecorator';
import AnnotationsOperationsHandler from './AnnotationsOperationsHandler';

// Annotations allow associating a range of text in the editor with something
// outside the editor and keeping the range up to date as the text changes.
const AnnotationsPlugin: EditorPlugin[] = [
  AnnotationsDecorator,
  AnnotationsOperationsHandler,
  AnnotationsChangeHandler,
  AnnotationsPastePlugin,
];

export default AnnotationsPlugin;
